// extracted by mini-css-extract-plugin
export default {"root":"PriceCard_root__gHNjM","section":"PriceCard_section__wI1pF"};